<template>
  <multiselect
    v-model="selected"
    @input="onChange"
    :options="isMulti ? filteredOptions : options"
    :custom-label="labelTipoEsporte"
    :multiple="isMulti"
    :taggable="isTagabble"
    selectLabel=""
    selectedLabel="«"
    deselectLabel=""
    :allowEmpty="allowEmpty"
    :preselectFirst="preselectFirst"
    :loading="isLoading"
    label="nome"
    track-by="id"
    :disabled="isDisabled"
    :class="isMulti ? 'multiselect-primary' : ''"
    placeholder=""
  >
    <template slot="noResult" slot-scope="props">
      <span>{{ $t('Nenhum elemento encontrado.') }}</span>
    </template>
    <template slot="noOptions" slot-scope="props">
      <span>{{ $t('Nenhum dado foi retornado.') }}</span>
    </template>
    <template slot="placeholder" slot-scope="props">
      <span>{{ $t(emptyLabel) }}</span>
    </template>
    <template slot="tag" slot-scope="{ option, remove }">
      <span class="multiselect__tag">
        <span v-if="option">{{ option.nome }}</span>
        <i
          aria-hidden="true"
          tabindex="1"
          class="multiselect__tag-icon"
          @click="isObject ? removeOption(option) : remove(option)"
        ></i>
      </span>
    </template>
    <template slot="clear" slot-scope="props">
      <div class="multiselect__clear" @mousedown.prevent.stop="clearAll(props.search)"></div>
    </template>
  </multiselect>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="@/vendor/libs/vue-multiselect/vue-multiselect.scss" lang="scss"></style>

<script>
import Multiselect from 'vue-multiselect';
export default {
  components: {
    Multiselect
  },
  props: [
    'nameField',
    'isRequired',
    'isDisabled',
    'emptyLabel',
    'includeAll',
    'isMulti',
    'isTagabble',
    'alreadyAdded',
    'preselectFirst',
    'allowEmpty',
    'optionsPersonalizados',
    'isObject',
    'hiddenSubEvents'
  ],

  data() {
    return {
      selected: [],
      value: [],
      options: [],
      isLoading: false
    };
  },

  computed: {
    filteredOptions() {
      return this.selected ? this.options.filter((option) => !this.selected.includes(option)) : this.options;
    }
  },

  methods: {
    onChange(e) {
      this.$emit('input', e);
      if (e == null) {
        this.$emit('selectChange', 'tipo_esporte', null);
        return;
      }
      if (this.isMulti || this.isTagabble) {
        let arr = new Array();
        if (this.isObject) {
          arr = e;
        } else {
          e.forEach((el) => {
            arr.push(el.id);
          });
        }
        this.$emit('selectChange', 'tipo_esporte', arr);
      } else {
        this.$emit('selectChange', 'tipo_esporte', e);
      }
    },
    labelTipoEsporte({ nome }) {
      return `${nome}`;
    },
    setValue(value) {
      if (this.isTagabble && this.isMulti) {
        this.selected = value;
        this.removeOptions(value);
        this.$emit('input', value);
        this.$emit('selectChange', 'tipo_esporte', value);
      } else {
        if (this.isMulti) {
          this.selected = new Array();
          if (value) {
            value.forEach((el) => {
              const element = this.options.find((option) => option.id === el);
              this.selected.push(element);
            });
          } else {
            this.selected = this.options.find((option) => option.id === value);
          }
        } else {
          if (value) {
            if (value.id) {
              this.selected = this.options.find((option) => option.id === value.id);
            } else {
              this.selected = this.options.find((option) => option.id === value);
            }
          } else {
            this.selected = this.options.find((option) => option.id === null);
          }
        }
        this.$emit('input', this.selected);
      }
    },
    clearAll() {
      this.value = [];
    },
    setOptions({ hiddenSubEvents }) {
      if (this.optionsPersonalizados) {
        this.options = [];
        if (this.includeAll) {
          this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
        }
        this.options = this.options.concat(this.optionsPersonalizados);
        this.setValue(this.nameField);
        return;
      }
      this.isLoading = true;
      let filter = null;
      if (hiddenSubEvents?.length > 0) {
        this.options = [];
        filter = `id NOT IN (${hiddenSubEvents.join(',')})`;
      }
      this.$atenaList
        .getTiposEsporte({ order: 'nome', filter })
        .then((res) => {
          if (this.includeAll) {
            this.options = [{ id: null, nome: this.$i18n.t(this.emptyLabel) }];
          }
          this.options = this.options.concat(res.data);
          if (this.alreadyAdded) {
            this.removeOptions(this.alreadyAdded);
          }
          this.setValue(this.nameField);
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
          this.$notify({
            group: 'notifications-default',
            type: 'error',
            title: this.$i18n.t('Erro ao Carregar Dados'),
            text: this.$i18n.t('Entre em contato com o Administrador do Sistema.')
          });
        });
    },
    removeOptions(options) {
      if (!options) return;
      let opt = [];
      this.options.forEach((element) => {
        const el = options.find((el) => el.id === element.id);
        if (!el) opt.push(element);
      });
      this.options = opt;
    },
    removeOption(option) {
      if (!option) return;
      let valueCp = [];
      this.selected.forEach((element) => {
        const el = this.selected.find((el) => el.id === option.id);
        if (el) {
          valueCp = this.selected.filter((elem) => elem.id != el.id);
        }
      });

      this.setValue(valueCp);
      this.options = this.$util.sortArray([option, ...this.options], 'nome');
    }
  },
  created() {
    this.setOptions({ hiddenSubEvents: this.hiddenSubEvents });
  },
  watch: {
    nameField: function (value) {
      this.setValue(value);
    },
    hiddenSubEvents: function (value) {
      if (value?.length > 0) {
        this.setOptions({ hiddenSubEvents: value });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.custom__remove {
  background: #26b4ff !important;
  color: #fff;
  transition: ease 0.2s all;
}

.custom__remove:hover {
  cursor: pointer;
  background: #0097e9 !important;
}
</style>
